import fetch from "@lib/fetch";

import { buildFetchRequestArgs } from "../formData";
import { reactQueryPostWebsocketAdapter } from "../reactQueryFetcherAdapters";
import { generativeAiAppGroupIdCampaignQa } from "./constants";
import type {
  PostwsGenerativeAiAppGroupIdCampaignQaPayload,
  PostwsGenerativeAiAppGroupIdCampaignQaProps,
} from "./types";
import { isCampaignQaResult } from "./validators";

export const postwsGenerativeAiAppGroupIdCampaignQa = reactQueryPostWebsocketAdapter(
  generativeAiAppGroupIdCampaignQa,
  async (
    signal,
    { appGroupId, agentIds, campaignDocument, jobToken, briefFile }: PostwsGenerativeAiAppGroupIdCampaignQaProps
  ): Promise<{}> => {
    const payload: PostwsGenerativeAiAppGroupIdCampaignQaPayload = {
      job_token: jobToken,
      agent_ids: agentIds,
      // Multipart form-field flattening is lossy for the deeply nested campaign
      // document, so ship it as one JSON-encoded part when a brief is attached.
      campaign_document: briefFile ? JSON.stringify(campaignDocument) : campaignDocument,
    };
    const { params, options, setContentType } = buildFetchRequestArgs(payload, briefFile);

    return await fetch(
      `/${appGroupId}/generative_ai/campaign_qa`,
      "POST",
      params,
      { signal, ...options },
      {
        setContentType,
        propagateFetchRequestError: false,
      }
    );
  },
  isCampaignQaResult
);
